{
	"id": 7502,
	"moduleNumber": 2,
	"title": "The Professional Educator",
	"subtitle": "Act proactively to uphold ethical standards, protect students, and address colleague concerns responsibly.",
	"kgNodeId": "module-2",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 2 introduces the educator's professional role through a colleague-concern scenario centered on Ms. Kim, whose teaching style changes over a short period and appears to reduce student engagement. Learners distinguish collegial support from professional responsibility and decide when referral or escalation is appropriate.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
